import { PageTemplate } from '~/components/PageTemplate';
import { FooterCtaSection } from '~/components/HomepageV3/FooterCtaSection';
import { HeroSection } from '~/components/HomepageV3/HeroSection';
import { McpTeaserSection } from '~/components/HomepageV3/McpTeaserSection';
import { PopularReportsSection } from '~/components/HomepageV3/PopularReportsSection';
import { TechCategorySection } from '~/components/HomepageV3/TechCategorySection';
import { UseCasesSection } from '~/components/HomepageV3/UseCasesSection';
import { WhatIsSection } from '~/components/HomepageV3/WhatIsSection';

export const HomepageV3 = () => {
  return (
    <PageTemplate fluid sx={{ pb: 0 }} breadcrumbs={[]}>
      <HeroSection />
      <PopularReportsSection />
      <UseCasesSection />
      <McpTeaserSection />
      <TechCategorySection />
      <WhatIsSection />
      <FooterCtaSection />
    </PageTemplate>
  );
};
